import { useEffect } from "react"
import type { IntradayBatchMetadata } from "model/state"
import { useAppSelector, useAppStore } from "hooks/redux"
import { isBatchNewerThanPricing } from "helpers/intraday"
import { useDashboardId } from "../context/dashboard-id"

interface IntradayBatchAdvanceParams {
  isIntraday: boolean
  lastIntradayBatch: IntradayBatchMetadata | null | undefined
  intradayBatchMetadata: IntradayBatchMetadata | null | undefined
  intradayDataAvailable: boolean
  isEndDateIntraday: boolean
  intradayPricingAsOf: string | null | undefined
  setIntradayBatchMetadata: (metadata: IntradayBatchMetadata | null) => void
}

export function useIntradayBatchAdvance({
  isIntraday,
  lastIntradayBatch,
  intradayBatchMetadata,
  intradayDataAvailable,
  isEndDateIntraday,
  intradayPricingAsOf,
  setIntradayBatchMetadata,
}: IntradayBatchAdvanceParams): void {
  const dashboardId = useDashboardId()
  const store = useAppStore()
  const tradeCount = useAppSelector((s) => s.dashboard.trade[dashboardId]?.trades?.length ?? 0)

  useEffect(() => {
    if (!isIntraday || !lastIntradayBatch || tradeCount > 0) {
      return
    }

    if (store.getState().dashboard.trade[dashboardId]?.trades?.length) {
      return
    }

    if (isIntraday && intradayDataAvailable && !isEndDateIntraday) {
      return
    }

    if (lastIntradayBatch.asOf !== intradayBatchMetadata?.asOf && isBatchNewerThanPricing(lastIntradayBatch, intradayPricingAsOf)) {
      setIntradayBatchMetadata({
        date: lastIntradayBatch.date,
        asOf: lastIntradayBatch.asOf,
        id: lastIntradayBatch.id,
      })
    }
  }, [isIntraday, lastIntradayBatch, setIntradayBatchMetadata, intradayBatchMetadata, tradeCount, intradayDataAvailable, isEndDateIntraday, intradayPricingAsOf, store, dashboardId])
}
